import {
  fetchBanks,
  fetchRepairCompanies,
  fetchDamageCauses,
  fetchOrganizations,
  fetchPropertyTypes,
} from '../../api/claimApplicationApi';

const GET_BANKS = 'efes/claimApplication/GET_BANKS';
const GET_BANKS_SUCCESS = 'efes/claimApplication/GET_BANKS_SUCCESS';
const GET_BANKS_FAIL = 'efes/claimApplication/GET_BANKS_FAIL';

const GET_REPAIR_COMPANIES = 'efes/claimApplication/GET_REPAIR_COMPANIES';
const GET_REPAIR_COMPANIES_SUCCESS = 'efes/claimApplication/GET_REPAIR_COMPANIES_SUCCESS';
const GET_REPAIR_COMPANIES_FAIL = 'efes/claimApplication/GET_REPAIR_COMPANIES_FAIL';

const GET_PROPERTY_TYPES = 'efes/claimApplication/GET_PROPERTY_TYPES';
const GET_PROPERTY_TYPES_SUCCESS = 'efes/claimApplication/GET_PROPERTY_TYPES_SUCCESS';
const GET_PROPERTY_TYPES_FAIL = 'efes/claimApplication/GET_PROPERTY_TYPES_FAIL';

const GET_DAMAGE_CAUSES = 'efes/claimApplication/GET_DAMAGE_CAUSES';
const GET_DAMAGE_CAUSES_SUCCESS = 'efes/claimApplication/GET_DAMAGE_CAUSES_SUCCESS';
const GET_DAMAGE_CAUSES_FAIL = 'efes/claimApplication/GET_DAMAGE_CAUSES_FAIL';

const GET_ORGANIZATIONS = 'efes/claimApplication/GET_ORGANIZATIONS';
const GET_ORGANIZATIONS_SUCCESS = 'efes/claimApplication/GET_ORGANIZATIONS_SUCCESS';
const GET_ORGANIZATIONS_FAIL = 'efes/claimApplication/GET_ORGANIZATIONS_FAIL';

const initialState = {
  banks: [],
  repairCompanies: [],
  propertyTypes: [],
  damageCauses: [],
  organizations: [],
  isLoadingBanks: false,
  isLoadingRepairCompanies: false,
  isLoadingPropertyTypes: false,
  isLoadingDamageCauses: false,
  isLoadingOrganizations: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_BANKS:
      return {
        ...state,
        isLoadingBanks: true,
      };
    case GET_BANKS_SUCCESS:
      return {
        ...state,
        banks: action.result,
        isLoadingBanks: false,
      };
    case GET_BANKS_FAIL:
      return {
        ...state,
        error: action.error,
        isLoadingBanks: false,
      };

    case GET_REPAIR_COMPANIES:
      return {
        ...state,
        isLoadingRepairCompanies: true,
      };
    case GET_REPAIR_COMPANIES_SUCCESS:
      return {
        ...state,
        repairCompanies: action.result,
        isLoadingRepairCompanies: false,
      };
    case GET_REPAIR_COMPANIES_FAIL:
      return {
        ...state,
        error: action.error,
        isLoadingRepairCompanies: false,
      };

    case GET_PROPERTY_TYPES:
      return {
        ...state,
        isLoadingPropertyTypes: true,
      };
    case GET_PROPERTY_TYPES_SUCCESS:
      return {
        ...state,
        propertyTypes: action.result,
        isLoadingPropertyTypes: false,
      };
    case GET_PROPERTY_TYPES_FAIL:
      return {
        ...state,
        error: action.error,
        isLoadingPropertyTypes: false,
      };

    case GET_DAMAGE_CAUSES:
      return {
        ...state,
        isLoadingDamageCauses: true,
      };
    case GET_DAMAGE_CAUSES_SUCCESS:
      return {
        ...state,
        damageCauses: action.result,
        isLoadingDamageCauses: false,
      };
    case GET_DAMAGE_CAUSES_FAIL:
      return {
        ...state,
        error: action.error,
        isLoadingDamageCauses: false,
      };

    case GET_ORGANIZATIONS:
      return {
        ...state,
        isLoadingOrganizations: true,
      };
    case GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.result,
        isLoadingOrganizations: false,
      };
    case GET_ORGANIZATIONS_FAIL:
      return {
        ...state,
        error: action.error,
        isLoadingOrganizations: false,
      };

    default:
      return state;
  }
}

export function getBanks() {
  return {
    actions: [
      { type: GET_BANKS },
      { type: GET_BANKS_SUCCESS },
      { type: GET_BANKS_FAIL, showError: true },
    ],
    promise: fetchBanks(),
  };
}

export function getRepairCompanies() {
  return {
    actions: [
      { type: GET_REPAIR_COMPANIES },
      { type: GET_REPAIR_COMPANIES_SUCCESS },
      { type: GET_REPAIR_COMPANIES_FAIL, showError: true },
    ],
    promise: fetchRepairCompanies(),
  };
}

export function getPropertyTypes() {
  return {
    actions: [
      { type: GET_PROPERTY_TYPES },
      { type: GET_PROPERTY_TYPES_SUCCESS },
      { type: GET_PROPERTY_TYPES_FAIL, showError: true },
    ],
    promise: fetchPropertyTypes(),
  };
}

export function getDamageCauses() {
  return {
    actions: [
      { type: GET_DAMAGE_CAUSES },
      { type: GET_DAMAGE_CAUSES_SUCCESS },
      { type: GET_DAMAGE_CAUSES_FAIL, showError: true },
    ],
    promise: fetchDamageCauses(),
  };
}

export function getOrganizations() {
  return {
    actions: [
      { type: GET_ORGANIZATIONS },
      { type: GET_ORGANIZATIONS_SUCCESS },
      { type: GET_ORGANIZATIONS_FAIL, showError: true },
    ],
    promise: fetchOrganizations(),
  };
}
